import { Box, Button, ButtonRow, FormSection, SuccessAnimation, Text } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { useEffect } from 'react';
import { formatString } from '@common/utils/formatString';
import { getDisplayName } from '@common/utils/getDisplayName';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAccountRequestAuthorization } from '@frontend/utils/assertHasAuthorization';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';

export function AccountRequestApprovedView() {
    const translate = getSelectedLanguage();
    const { accountRequest } = useAccountRequestContext();

    const navigate = useNavigate();

    useEffect(() => {
        if (accountRequest.approverPractitionerId) {
            assertHasAccountRequestAuthorization('read');
        }
    }, [accountRequest.approverPractitionerId]);

    return (
        <>
            <Box
                display="flex"
                justifyContent="center"
                mt={4}
            >
                <SuccessAnimation size="large" />
            </Box>
            <Text textAlign="center">
                {formatString(translate.accountRequest.willReceiveNotificationEmail, [
                    getDisplayName(accountRequest.userData.practitioner),
                ])}
            </Text>
            <FormSection
                isBorderless
                sx={{ marginTop: [11, 14] }}
            >
                <ButtonRow>
                    <Button
                        onClick={() => navigate('/home')}
                        width="full"
                    >
                        {translate.accountRequest.openTheKsyosPlatform}
                    </Button>
                </ButtonRow>
            </FormSection>
        </>
    );
}
